/**
 * engines/constants
 *
 * 物理定数と単位変換。すべてSI単位系を基本とし、AU・太陽質量・年など
 * 天文学で慣用的な単位への変換ヘルパーを提供する。
 *
 * この層は他のどのenginesモジュールにも依存しない、最も下位のレイヤー。
 */

// ---- 基礎物理定数 (SI単位) ----

/** 万有引力定数 [m^3 kg^-1 s^-2] */
export const G = 6.6743e-11;

/** 光速 [m/s] */
export const SPEED_OF_LIGHT = 2.99792458e8;

/** シュテファン-ボルツマン定数 [W m^-2 K^-4] */
export const STEFAN_BOLTZMANN = 5.670374419e-8;

// ---- 天文学的な基準値 ----

/** 太陽質量 [kg] */
export const SOLAR_MASS = 1.98892e30;

/** 太陽半径 [m] */
export const SOLAR_RADIUS = 6.957e8;

/** 太陽光度 [W] */
export const SOLAR_LUMINOSITY = 3.828e26;

/** 太陽の有効温度 [K] */
export const SOLAR_TEMPERATURE = 5778;

/** 地球質量 [kg] */
export const EARTH_MASS = 5.9722e24;

/** 地球半径 (平均) [m] */
export const EARTH_RADIUS = 6.371e6;

/** 天文単位 (地球-太陽の平均距離) [m] */
export const AU = 1.495978707e11;

/** ユリウス年 [s] （365.25日） */
export const YEAR = 365.25 * 24 * 3600;

/** 1日 [s] */
export const DAY = 24 * 3600;

// ---- 単位変換ヘルパー ----

/** 太陽質量単位からkgへ */
export const solarMassToKg = (mSun: number): number => mSun * SOLAR_MASS;

/** kgから太陽質量単位へ */
export const kgToSolarMass = (kg: number): number => kg / SOLAR_MASS;

/** AUからmへ */
export const auToMeters = (au: number): number => au * AU;

/** mからAUへ */
export const metersToAu = (m: number): number => m / AU;

/** 年(ユリウス年)から秒へ */
export const yearsToSeconds = (yr: number): number => yr * YEAR;

/** 秒から年(ユリウス年)へ */
export const secondsToYears = (s: number): number => s / YEAR;
